import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom"; // import BrowserRouter, Route, and Switch from react-router-dom
import Login from "./pages/login";
import PatientPortal from "./pages/portal-login";
import Register from "./pages/register";
import { Toaster } from "react-hot-toast";
import Home from "./pages/home";  
import {useSelector} from "react-redux";
import {
  LandingRoute,
  StaffPublicRoute,
  PatientPublicRoute,
  PatientProtectedRoute,
  ProtectedRoute,
} from "./components/AppRoutes";
import PatientDashboard from "./pages/Patient/patientdashboard";
import ApplyDoctor from "./pages/apply_doctor";
import Notifications from "./pages/notifications";
import DoctorsList from "./pages/Admin/doctorslist";
import UsersList from "./pages/Admin/userslist";
import Service from "./pages/Admin/service";
import Location from "./pages/Admin/location";
import Speciality from "./pages/Admin/speciality";
import Profile from "./pages/Doctor/Profile";
import BookAppointment from "./pages/BookAppointment";
import Appointments from "./pages/appointment";
import DoctorAppointments from "./pages/Doctor/DoctorAppointment";
import StaffRegister from "./pages/Admin/staff-register";
import AppointmentAdmin from "./pages/Admin/appointment-admin";
import Slots from "./pages/Admin/slots";
import ResetPassword from "./pages/reset_password";
import ConfirmOTP from "./pages/confirm_otp";
import DoctorSlotsStatus from "./pages/Admin/doctorslots-status";
import SubmitReview from "./pages/reviewSubmission";
import ManageReviews from "./pages/Admin/ManageReview";
import MarkAppoinmtentCompleted from "./pages/Doctor/markApp-completed";
import MediaImageUpload from "./pages/Admin/media-image-uploads";
import AdminCompleteAppointment from "./pages/Admin/AdminMarkApp-completed";
import VerifyOtp from "./pages/verify-otp";
import AdminScheduleDoctor from "./pages/Admin/adminDoctorSchedule";
import CreateClinicDay from "./pages/Admin/CreateClinicDay";
import AdminHome from "./pages/Admin/AdminHome";
import Unauthorised from "./pages/unauthorised"
import StaffList from "./pages/Admin/stafflist";
import AdminList from "./pages/Admin/adminlist";
import StaffHome from "./pages/Staff/StaffHome";
import StaffCompleteAppointment from "./pages/Admin/AdminMarkApp-completed";
import AppointmentStaff  from "./pages/Admin/appointment-admin";
import StaffManageReviews from "./pages/Admin/ManageReview";
import StaffScheduleDoctor from "./pages/Admin/adminDoctorSchedule";
import StaffDoctorsList from "./pages/Admin/doctorslist";
import StaffUsersList from "./pages/Admin/userslist";
import DoctorHome from "./pages/Doctor/DoctorHome";
import AppointmentReport from "./pages/Admin/appointmentReport";
import AppointmentCanceled from "./pages/Admin/adminCancelappointment"; // Import the new component
import SchedulePatient from "./pages/schedule_appointment"; 
import PortalLanding from "./pages/PortalLanding";
import AddPatient from "./pages/Admin/addpatient";
import AdminBookAppointment from "./pages/Admin/bookpatient";
import usePWAInstall from './hooks/usePWAInstall';
import { FloatButton } from 'antd';
import { DownloadOutlined, CloseOutlined } from '@ant-design/icons';
import ForgetPassword from "./pages/ForgetPassword";

window.process = {
  env: {
    NODE_ENV: 'production' // Change to 'production' if needed
  }
};



function App() {
  const {loading} = useSelector((state) => state.alerts);
  const { showInstallButton, installPWA, dismissInstallButton } = usePWAInstall(); 
  return (
   <BrowserRouter>
      {loading && (
        <div className="spinner-parent">
          <div className="spinner-border" role="status"></div>
        </div>
      )}
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>

        {/* ── Channel selector / landing ──────────────────────────
            Logged-in users are sent to their own dashboard.
            Everyone else sees the two-card landing page.          */}
        <Route path="/"
          element={<LandingRoute><PortalLanding /></LandingRoute>}
        />

        {/* ── Appointment-app user home (was "/") ─────────────── */}
        <Route path="/home"
          element={<ProtectedRoute roleType="user"><Home /></ProtectedRoute>}
        />

        <Route path="/unauthorised" element={<Unauthorised />} />

        {/* ── Staff / doctor / admin auth pages ───────────────────
            StaffPublicRoute sends already-logged-in users to their
            correct dashboard instead of the old broken "/" bounce. */}
        <Route path="/Login"
          element={<StaffPublicRoute><Login /></StaffPublicRoute>}
        />
        <Route path="/Register"
          element={<StaffPublicRoute><Register /></StaffPublicRoute>}
        />
        <Route path="/reset-password"
          element={<StaffPublicRoute><ResetPassword /></StaffPublicRoute>}
        />
        <Route path="/confirm-otp"
          element={<StaffPublicRoute><ConfirmOTP /></StaffPublicRoute>}
        />
        <Route path="/verify-otp"
          element={<StaffPublicRoute><VerifyOtp /></StaffPublicRoute>}
        />

        {/* ── Patient auth page ───────────────────────────────────
            PatientPublicRoute sends already-logged-in patients (or
            staff) directly to their dashboard.                    */}
        <Route path="/portal-login"
          element={<PatientPublicRoute><PatientPortal /></PatientPublicRoute>}
        />
           <Route path="/forget-password"
          element={<PatientPublicRoute><ForgetPassword /></PatientPublicRoute>}
        />

        {/* ── Patient dashboard ───────────────────────────────────
            Requires a valid patientToken. No token → /portal-login */}
        <Route path="/patient/patientdashboard"
          element={<PatientProtectedRoute><PatientDashboard /></PatientProtectedRoute>}
        />

        {/* ── Appointment-app user routes ──────────────────────── */}
        <Route path="/apply-doctor"   element={<ProtectedRoute><ApplyDoctor /></ProtectedRoute>} />
        <Route path="/notifications"  element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
        <Route path="/book-appointment/:doctorId" element={<ProtectedRoute><BookAppointment /></ProtectedRoute>} />
        <Route path="/appointments"   element={<ProtectedRoute><Appointments /></ProtectedRoute>} />
        <Route path="/reviewSubmission" element={<ProtectedRoute><SubmitReview /></ProtectedRoute>} />
        <Route path="/user/scheduled-patient" element={<ProtectedRoute roleType="admin"><SchedulePatient /></ProtectedRoute>} />

        {/* ── Doctor routes ───────────────────────────────────── */}
        <Route path="/doctor/home"    element={<ProtectedRoute roleType="doctor"><DoctorHome /></ProtectedRoute>} />
        <Route path="/doctor/profile/:userId" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/doctor/appointments" element={<ProtectedRoute><DoctorAppointments /></ProtectedRoute>} />
        <Route path="/doctor/markapp-completed" element={<ProtectedRoute><MarkAppoinmtentCompleted /></ProtectedRoute>} />

        {/* ── Admin routes ─────────────────────────────────────── */}
        <Route path="/admin/home"     element={<ProtectedRoute roleType="admin"><AdminHome /></ProtectedRoute>} />
        <Route path="/admin/appointments-report" element={<ProtectedRoute roleType="admin"><AppointmentReport /></ProtectedRoute>} />
        <Route path="/admin/appointments-cancel" element={<ProtectedRoute roleType="admin"><AppointmentCanceled /></ProtectedRoute>} />
        <Route path="/admin/doctorslist"  element={<ProtectedRoute><DoctorsList /></ProtectedRoute>} />
        <Route path="/admin/stafflist"    element={<ProtectedRoute><StaffList /></ProtectedRoute>} />
        <Route path="/admin/userslist"    element={<ProtectedRoute><UsersList /></ProtectedRoute>} />
        <Route path="/admin/adminlist"    element={<ProtectedRoute><AdminList /></ProtectedRoute>} />
        <Route path="/admin/profile"      element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/admin/service"      element={<ProtectedRoute><Service /></ProtectedRoute>} />
        <Route path="/admin/location"     element={<ProtectedRoute><Location /></ProtectedRoute>} />
        <Route path="/admin/speciality"   element={<ProtectedRoute><Speciality /></ProtectedRoute>} />
        <Route path="/admin/staff-register" element={<ProtectedRoute><StaffRegister /></ProtectedRoute>} />
        <Route path="/admin/slots"        element={<ProtectedRoute><Slots /></ProtectedRoute>} />
        <Route path="/admin/doctorslots-status" element={<ProtectedRoute><DoctorSlotsStatus /></ProtectedRoute>} />
        <Route path="/admin/manage-review" element={<ProtectedRoute><ManageReviews /></ProtectedRoute>} />
        <Route path="/admin/media-image-uploads" element={<ProtectedRoute><MediaImageUpload /></ProtectedRoute>} />
        <Route path="/admin/admin-mark-app-completed" element={<ProtectedRoute><AdminCompleteAppointment /></ProtectedRoute>} />
        <Route path="/admin/doctor-schedule" element={<ProtectedRoute><AdminScheduleDoctor /></ProtectedRoute>} />
        <Route path="/admin/create-clinic-day" element={<ProtectedRoute><CreateClinicDay /></ProtectedRoute>} />
        <Route path="/admin/appointments-admin" element={<ProtectedRoute><AppointmentAdmin /></ProtectedRoute>} />
        <Route path="/admin/add-patient" element={<ProtectedRoute roleType="admin"><AddPatient/></ProtectedRoute>} />
        <Route path="/admin/book-patient" element={<ProtectedRoute roleType="admin"><AdminBookAppointment /></ProtectedRoute>} />
        

        {/* ── Staff routes ─────────────────────────────────────── */}
        <Route path="/staff/home"     element={<ProtectedRoute roleType="staff"><StaffHome /></ProtectedRoute>} />
        <Route path="/staff/adminlist"  element={<ProtectedRoute><AdminList /></ProtectedRoute>} />
        <Route path="/staff/doctorlist" element={<ProtectedRoute><StaffDoctorsList /></ProtectedRoute>} />
        <Route path="/staff/userlist"   element={<ProtectedRoute><StaffUsersList /></ProtectedRoute>} />
        <Route path="/staff/staff-mark-app-completed" element={<ProtectedRoute><StaffCompleteAppointment /></ProtectedRoute>} />
        <Route path="/staff/doctor-schedule" element={<ProtectedRoute><StaffScheduleDoctor /></ProtectedRoute>} />
        <Route path="/staff/appointments-staff" element={<ProtectedRoute><AppointmentStaff /></ProtectedRoute>} />
        <Route path="/staff/manage-review" element={<ProtectedRoute><StaffManageReviews /></ProtectedRoute>} />

      </Routes>

      {/* PWA Install Button - Floating */}
      {showInstallButton && (
        <FloatButton.Group 
          shape="circle" 
          style={{ right: 24, bottom: 80 }}   // Adjusted bottom to avoid overlapping other buttons
        >
          <FloatButton
            icon={<CloseOutlined />}
            onClick={dismissInstallButton}
            tooltip="Don't show again"
          />
          <FloatButton
            type="primary"
            icon={<DownloadOutlined />}
            onClick={installPWA}
            tooltip="Install HMS Appointment App"
            style={{ backgroundColor: '#1677ff' }}
          />
        </FloatButton.Group>
      )}
    </BrowserRouter>
  );
}

export default App;
